module.exports = __webpack_public_path__ + "static/media/Soybean7R1.d57a8783.PNG";